"use strict";
/**
 * @file Created on 03/03/2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ResourceLockType_1 = require("../../resource-lock/enums/ResourceLockType");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var ForecastSimulationLockDTO_1 = require("../model/ForecastSimulationLockDTO");

var ForecastSimulationLockDTOConverter_1 = require("./ForecastSimulationLockDTOConverter");
/**
 * @author Tomas Leity
 */


var ForecastSimulationLockDTOConverterImpl =
/*#__PURE__*/
function (_ForecastSimulationLo) {
  _inherits(ForecastSimulationLockDTOConverterImpl, _ForecastSimulationLo);

  function ForecastSimulationLockDTOConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, ForecastSimulationLockDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationLockDTOConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ForecastSimulationLockDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ForecastSimulationLockDTO_1.ForecastSimulationLockDTO(ForecastSimulationLockDTO_1.ForecastSimulationLockDTO.schema.promotionId.valueOf(source.promotionId), ForecastSimulationLockDTO_1.ForecastSimulationLockDTO.schema.resourceId.valueOf(source.resourceId), ForecastSimulationLockDTO_1.ForecastSimulationLockDTO.schema.resourceLockType.valueOf(conversions.asEnum(source.resourceLockType, ResourceLockType_1.ResourceLockType)), ForecastSimulationLockDTO_1.ForecastSimulationLockDTO.schema.assignee.valueOf(conversions.asObjectOpt(source, 'assignee', function (doc) {
        return _this2.userInfoConverter.toObject(doc, conversions);
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        promotionId: source.promotionId,
        resourceId: source.resourceId,
        resourceLockType: source.resourceLockType,
        assignee: conversions.asObjectOpt(source, 'assignee', function (userInfo) {
          return _this3.userInfoConverter.toDocument(userInfo, conversions);
        })
      };
    }
  }]);

  return ForecastSimulationLockDTOConverterImpl;
}(ForecastSimulationLockDTOConverter_1.ForecastSimulationLockDTOConverter);

ForecastSimulationLockDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], ForecastSimulationLockDTOConverterImpl);
exports.ForecastSimulationLockDTOConverterImpl = ForecastSimulationLockDTOConverterImpl;